export default class Local {
	constructor(_app) {
		this._back = _app.getService("backend");
		this._data = new Map();
	}

	rules(now) {
		return getColl(this._data, 1, () => this._back.rules(), now);
	}

	users(now) {
		// init meta data loading
		const meta = this.meta();
		return getColl(this._data, 2, () => this._back.users(), now, c => {
			return meta.then(links => {
				links.UserRule.forEach(a => {
					const obj = c.getItem(a[0]);
					if (obj) {
						if (!obj.rules) obj.rules = [];
						obj.rules.push(a[1]);
					}
				});

				links.UserRole.forEach(a => {
					const obj = c.getItem(a[0]);
					if (obj) {
						if (!obj.roles) obj.roles = [];
						obj.roles.push(a[1]);
					}
				});
				return c;
			});
		});
	}

	roles(now) {
		// init meta data loading
		const meta = this.meta();
		return getColl(this._data, 3, () => this._back.roles(), now, c => {
			return meta.then(links => {
				links.RoleRule.forEach(a => {
					const obj = c.getItem(a[0]);
					if (obj) {
						if (!obj.rules) obj.rules = [];
						obj.rules.push(a[1]);
					}
				});
				return c;
			});
		});
	}

	meta(now) {
		return getSome(this._data, 4, () => this._back.meta(), now);
	}

	logsMeta(now) {
		return getSome(this._data, 5, () => this._back.logsMeta(), now);
	}
}

function getColl(store, key, handler, now, post) {
	if (!store.has(key)) {
		const x = {
			promise: handler().then(data => {
				x.obj.parse(data);
				return x.obj;
			}),
			obj: new webix.DataCollection({}),
		};
		if (post) x.promise = x.promise.then(post);
		store.set(key, x);
	}

	const x = store.get(key);
	return now ? x.obj : x.promise;
}

function getSome(store, key, handler, now) {
	if (!store.has(key)) {
		const x = {
			promise: handler().then(data => (x.obj = data)),
			obj: null,
		};
		store.set(key, x);
	}

	const x = store.get(key);
	return now ? x.obj : x.promise;
}
